// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import { PROMOTION_VISIBLE, FULLY_VISIBLE } from '@tcp/core/src/constants/rum.constants';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import { isTier1Device } from '@tcp/web/src/utils/device-tiering';
import { getAssetHostURL, getIconPath } from '@tcp/core/src/utils/utils';
import { getBrandName } from '@tcp/core/src/utils/utils.web';
import DiscoveryButton from '@tcp/web/src/components/common/vendors/Syte/DiscoveryButton';
import AnimatedSearchIcon from '@tcp/web/src/components/common/atoms/AnimatedSearchIcon';
import NextSeo from '@tcp/web/src/components/common/atoms/SEO';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import { getSeoProps } from './Bundleutils';
import Carousel from '../../../../common/molecules/Carousel';
import withStyles from '../../../../common/hoc/withStyles';
import styles from '../styles/BundleProduct.style';
import ProductDescription from '../../ProductDetail/molecules/ProductDescription/views';
import FixedBreadCrumbs from '../../ProductListing/molecules/FixedBreadCrumbs/views';
import SocialConnect from '../../../../common/organisms/ProductImages/views/SocialConnect.view';
import Product from '../../ProductDetail/molecules/Product/views/Product.view';
import ProductDetailImage from '../../../../common/molecules/ProductDetailImage';
import BundleProductItems from '../molecules/BundleProductItems';
import { CAROUSEL_OPTIONS, IMG_DATA } from './config';
import {
  getImagesToDisplay,
  getMapSliceForColorProductId,
  checkInWishlistUtil,
  filterBundleImageUrl,
} from '../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import PromoPDPBanners from '../../../../common/organisms/PromoPDPBanners';
import ToastModal from '../../../account/common/molecule/ToastModal/views/ToastModal';

const Recommendations = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "recommendations" */ '@tcp/core/src/components/common/molecules/Recommendations'
  )
);

// SYTE Vendor Script
const SyteVendorScript = dynamic(() => import('@tcp/web/src/components/common/vendors/Syte/Syte'));

class BundleProduct extends React.PureComponent {
  state = {
    imagesToDisplay: [],
    showDiscoveryIcon: false,
    imageFlag: false,
    hasMounted: false,
  };

  static getDerivedStateFromProps(props) {
    const { currentProduct, isOnModelAbTestBundlePdp } = props;
    if (currentProduct) {
      let imagesToDisplay = [];
      const { colorFitsSizesMap, generalProductId } = currentProduct;

      if (colorFitsSizesMap) {
        imagesToDisplay = getImagesToDisplay({
          imagesByColor: currentProduct.imagesByColor,
          curentColorEntry: getMapSliceForColorProductId(colorFitsSizesMap, generalProductId),
          isAbTestActive: isOnModelAbTestBundlePdp,
          isFullSet: true,
        });
      }
      return {
        imagesToDisplay,
      };
    }
    return null;
  }

  dynamicBrowseLabels = getDynamicLabelValues('dynamic.browse_d');

  componentDidMount() {
    const { isSyteEnabled } = this.props;
    this.setState({ hasMounted: true });
    if (isSyteEnabled) this.setState({ showDiscoveryIcon: isSyteEnabled });
  }

  getBreadCrumb = () => {
    const { breadCrumbs } = this.props;
    if (breadCrumbs) {
      return (
        <Row>
          <Col colSize={{ small: 6, medium: 8, large: 12 }} className="breadcrum-wrapper">
            <FixedBreadCrumbs crumbs={breadCrumbs} separationChar=">" />
          </Col>
        </Row>
      );
    }
    return '';
  };

  getSocialConnectWidget = () => {
    return (
      <SocialConnect
        className="bundle-social-wrapper"
        isFacebookEnabled
        isPinterestEnabled
        isTwitterEnabled
      />
    );
  };

  checkInWishlist = (wishList, productId) => {
    return wishList && wishList[productId] && wishList[productId].isInDefaultWishlist;
  };

  getProductSummary = (currentColorEntry) => {
    const {
      currentProduct,
      productDetails,
      currency,
      currencyAttributes,
      onSetLastDeletedItemIdAction,
      wishList,
      isOutfitPage,
      errorMessages,
      alternateBrand,
      isHideOriginalPrice,
      ...otherProps
    } = this.props;

    const currencySign = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_GENERIC_LABELS}.lbl_currency`,
      GlobalGenericLabels
    );
    const selectedColorProductId = currentColorEntry && currentColorEntry.colorProductId;
    return (
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <div className="product-summary-wrapper">
            <Product
              productDetails={productDetails}
              isGiftCard={currentProduct.isGiftCard}
              selectedColorProductId={selectedColorProductId}
              currencySymbol={currency}
              currencyAttributes={currencyAttributes}
              isBundleProduct
              currencySign={currencySign}
              onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
              wishList={wishList}
              isInWishList={checkInWishlistUtil(wishList, selectedColorProductId)}
              isOutfitPage={isOutfitPage}
              errorMessages={errorMessages}
              alternateBrand={alternateBrand}
              isHideOriginalPrice={isHideOriginalPrice}
              {...otherProps}
            />
            {/* UX timer */}
            {/* TODO: When there is an actual promo image, revise timer logic */}
            <RenderPerf.Measure name={PROMOTION_VISIBLE} />
            <RenderPerf.Measure name={FULLY_VISIBLE} />
          </div>
        </Col>
      </Row>
    );
  };

  getBundleProductsList = () => {
    const {
      currentBundle,
      handleAddToBag,
      addToFavorites,
      addToBagEcom,
      currentState,
      isLoggedIn,
      addToBagErrorId,
      addToBagError,
      isKeepAliveEnabled,
      currencyAttributes,
      currency,
      AddToFavoriteErrorMsg,
      removeAddToFavoritesErrorMsg,
      isOnModelAbTestBundlePdp,
      isInternationalShipping,
      isEnabledOutfitAddedCTA,
      showAddedToBagCta,
      wishList,
      onSetLastDeletedItemIdAction,
      isOutfitPage,
      errorMessages,
      alternateBrand,
      isHideOriginalPriceAndMarchantTagEnabled,
      isBundleOutfitInfluencerHandleEnabled,
      isSplittingExtendedSizesEnabled,
    } = this.props;

    return (
      <Row fullBleed className="product-items-section">
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <BundleProductItems
            currentBundle={currentBundle}
            handleAddToBag={handleAddToBag}
            addToFavorites={addToFavorites}
            addToBagEcom={addToBagEcom}
            currentState={currentState}
            isLoggedIn={isLoggedIn}
            addToBagErrorId={addToBagErrorId}
            addToBagError={addToBagError}
            isKeepAliveEnabled={isKeepAliveEnabled}
            currencySymbol={currency}
            currencyAttributes={currencyAttributes}
            className="bundle-products-list"
            AddToFavoriteErrorMsg={AddToFavoriteErrorMsg}
            removeAddToFavoritesErrorMsg={removeAddToFavoritesErrorMsg}
            isOnModelAbTestBundlePdp={isOnModelAbTestBundlePdp}
            isInternationalShipping={isInternationalShipping}
            showAddedToBagCta={showAddedToBagCta}
            isEnabledOutfitAddedCTA={isEnabledOutfitAddedCTA}
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            wishList={wishList}
            isOutfitPage={isOutfitPage}
            errorMessages={errorMessages}
            alternateBrand={alternateBrand}
            isHideOriginalPriceAndMarchantTagEnabled={isHideOriginalPriceAndMarchantTagEnabled}
            isBundleOutfitInfluencerHandleEnabled={isBundleOutfitInfluencerHandleEnabled}
            isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
          />
        </Col>
      </Row>
    );
  };

  getProductDescription = (currentColorEntry) => {
    const {
      itemPartNumber,
      shortDescription,
      longDescription,
      currentProduct,
      onSetLastDeletedItemIdAction,
      wishList,
      isOutfitPage,
      errorMessages,
      alternateBrand,
    } = this.props;
    const itemColor = currentColorEntry && currentColorEntry.color && currentColorEntry.color.name;
    return (
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <ProductDescription
            productInfo={currentProduct}
            productId={itemPartNumber}
            isShowMore={false}
            shortDescription={shortDescription}
            longDescription={longDescription}
            color={itemColor}
            isBundleProduct
            onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
            wishList={wishList}
            isInWishList={checkInWishlistUtil(wishList, itemPartNumber)}
            isOutfitPage={isOutfitPage}
            errorMessages={errorMessages}
            alternateBrand={alternateBrand}
          />
        </Col>
        <Col colSize={{ small: 3, medium: 3, large: 3 }}>{this.getSocialConnectWidget()}</Col>
      </Row>
    );
  };

  // This is required for reommendations.
  getCatIdForRecommendation = () => {
    const { breadCrumbs } = this.props;
    if (breadCrumbs) {
      const category = breadCrumbs.map((crumb, index) => {
        const { displayName } = crumb;
        const separationChar = index !== breadCrumbs.length - 1 ? ':' : '';
        return displayName + separationChar;
      });
      return category.join('');
    }
    return '';
  };

  getRecommendations = () => {
    const youMayAlsoLike = renderLabel(
      this.dynamicBrowseLabels.lbl_you_may_also_like_collection,
      'lbl_you_may_also_like_collection'
    );

    const recentlyViewed = renderLabel(
      this.dynamicBrowseLabels.lbl_recently_viewed_collection,
      'lbl_recently_viewed_collection'
    );

    const { itemPartNumber, currentProduct } = this.props;
    const { primaryCategory } = currentProduct;

    const willMonetateCarouselDisplay = isTier1Device();
    const categoryId = this.getCatIdForRecommendation();
    const recommendationAttributes = {
      variations: 'moduleO',
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.COLLECTION,
      categoryName: categoryId,
      partNumber: itemPartNumber,
      showLoyaltyPromotionMessage: false,
      headerAlignment: 'left',
      priceOnly: true,
      recommendationCarouselRedesign: true,
      primaryCategory: primaryCategory || '',
    };
    return (
      <div className="product-detail-section">
        <Recommendations headerLabel={youMayAlsoLike} {...recommendationAttributes} sequence="1" />
        {willMonetateCarouselDisplay && (
          <Recommendations
            headerLabel={recentlyViewed}
            portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
            {...recommendationAttributes}
            sequence="2"
          />
        )}
      </div>
    );
  };

  onImageLoad = () => {
    this.setState({ imageFlag: true });
  };

  renderPlpPdpMainImage = () => {
    const { currentProduct, isOutfitPage, alternateBrand, plpImagesToDisplay, isFromBundlePage } =
      this.props;
    const { imageFlag } = this.state;
    const primaryBrand = currentProduct?.primaryBrand || alternateBrand;
    if (plpImagesToDisplay?.length <= 0) {
      return this.getMainImageCarousel();
    }
    const plpImg = !imageFlag && (
      <ProductDetailImage
        className="outfit-carousal-image"
        imageUrl={plpImagesToDisplay?.[0]?.bigSizeImageUrl}
        imageName={currentProduct.name}
        isZoomEnabled={false}
        imageConfig={IMG_DATA.imgConfig}
        isOutfitPage={isOutfitPage}
        primaryBrand={primaryBrand}
        fromPLPPage={true}
        isFromBundlePage={isFromBundlePage}
      />
    );
    if (!imageFlag) {
      return (
        <>
          {plpImg}
          <ProductDetailImage
            className="outfit-carousal-image"
            imageUrl={plpImagesToDisplay?.[0]?.bigSizeImageUrl}
            imageName={currentProduct.name}
            isZoomEnabled={false}
            imageConfig={IMG_DATA.imgConfig}
            isOutfitPage={isOutfitPage}
            primaryBrand={primaryBrand}
            fromPLPPage={false}
            onLoadImage={this.onImageLoad()}
            isFromBundlePage={isFromBundlePage}
          />
        </>
      );
    }
    return this.getMainImageCarousel();
  };

  getMainImageCarousel = () => {
    const { currentProduct, isOutfitPage, alternateBrand, isFromBundlePage } = this.props;
    const { imagesToDisplay } = this.state;
    const primaryBrand = currentProduct?.primaryBrand || alternateBrand;
    return (
      <>
        {imagesToDisplay && imagesToDisplay.length === 1 ? (
          <ProductDetailImage
            className="outfit-carousal-image"
            imageUrl={filterBundleImageUrl(imagesToDisplay?.[0]?.bigSizeImageUrl)}
            imageName={currentProduct.name}
            isZoomEnabled={false}
            imageConfig={IMG_DATA.imgConfig}
            isOutfitPage={isOutfitPage}
            primaryBrand={primaryBrand}
            fromPLPPage={false}
            isFromBundlePage={isFromBundlePage}
          />
        ) : (
          <Carousel
            options={CAROUSEL_OPTIONS}
            carouselConfig={{
              autoplay: false,
            }}
          >
            {imagesToDisplay &&
              imagesToDisplay.map((image) => {
                const imgFilteredUrl = filterBundleImageUrl(image?.bigSizeImageUrl);
                return (
                  <ProductDetailImage
                    className="outfit-carousal-image"
                    imageUrl={imgFilteredUrl}
                    imageName={currentProduct.name}
                    isZoomEnabled={false}
                    imageConfig={IMG_DATA.imgConfig}
                    isOutfitPage={isOutfitPage}
                    primaryBrand={primaryBrand}
                    fromPLPPage={false}
                    isFromBundlePage={isFromBundlePage}
                  />
                );
              })}
          </Carousel>
        )}
      </>
    );
  };

  renderDiscoveryButton = (SyteConfig) => {
    const shopSimilarLabel = getLabelFromCopyOrFromTranslation(
      `${GLOBAL_COMMON_BROWSE_LABELS}.lbl_shop_similar`,
      globalCommonBrowseLabels
    );

    const { showDiscoveryIcon } = this.state;
    return (
      showDiscoveryIcon && (
        <div className="syte-container-wrapper">
          <DiscoveryButton config={SyteConfig}>
            <AnimatedSearchIcon
              iconLabel={shopSimilarLabel}
              iconPath={getIconPath('cta-search')}
              disableAnimation
            />
          </DiscoveryButton>
        </div>
      )
    );
  };

  renderSeoSection = (currentProduct) => {
    const seoProps = getSeoProps(currentProduct);
    if (seoProps) {
      const { title, description } = seoProps;
      return <NextSeo title={title} description={description} />;
    }
    return null;
  };

  render() {
    const {
      className,
      currentProduct,
      topPromos,
      primaryBrand,
      alternateBrand,
      trackAnalyticsClick,
      isSyteEnabled,
      toastModalState,
      showToastModalAction,
    } = this.props;
    const { imagesToDisplay, hasMounted } = this.state;
    if (currentProduct && JSON.stringify(currentProduct) !== '{}') {
      const { colorFitsSizesMap, generalProductId } = currentProduct;
      const currentColorEntry = getMapSliceForColorProductId(colorFitsSizesMap, generalProductId);

      const SyteConfig = {
        image: `${getAssetHostURL()}/v1/ecom/assets/products/${getBrandName(
          primaryBrand,
          alternateBrand
        )}/${imagesToDisplay?.[0]?.regularSizeImageUrl}`,
        sku: generalProductId,
        placement: 'PDP',
        clickAnalytics: trackAnalyticsClick,
      };
      // Syte Script
      const Syte = isSyteEnabled ? SyteVendorScript : () => null;

      return (
        <>
          {this.renderSeoSection(currentProduct)}
          <div className={className}>
            {this.getBreadCrumb()}
            <Row className="product-container">
              <Col colSize={{ small: 6, medium: 8, large: 12 }}>
                {topPromos && topPromos.length > 0 && <PromoPDPBanners promos={topPromos} />}
              </Col>
              <Col colSize={{ small: 6, medium: 3, large: 6 }}>
                <BodyCopy
                  className={`hide-on-desktop hide-on-tablet ${className}`}
                  fontSize="fs18"
                  component="h1"
                  fontFamily="secondary"
                  fontWeight="extrabold"
                >
                  {currentProduct.name}
                </BodyCopy>
                {this.renderPlpPdpMainImage()}
                {this.renderDiscoveryButton(SyteConfig)}
              </Col>
              <Col colSize={{ small: 6, medium: 5, large: 6 }}>
                <Row fullBleed className="product-summary-section">
                  <Col
                    id="productDetailsSection"
                    className="product-detail-section"
                    colSize={{ small: 6, medium: 8, large: 12 }}
                  >
                    {this.getProductSummary(currentColorEntry)}
                    {this.getProductDescription(currentColorEntry)}
                  </Col>
                </Row>
                {this.getBundleProductsList()}
              </Col>
            </Row>
            {this.getRecommendations()}
            {hasMounted && <Syte />}
            {toastModalState?.showToast && (
              <ToastModal
                className={className}
                duration={toastModalState?.duration}
                showToastModalAction={showToastModalAction}
              />
            )}
          </div>
        </>
      );
    }
    return '';
  }
}

BundleProduct.propTypes = {
  className: PropTypes.string,
  shortDescription: PropTypes.string,
  itemPartNumber: PropTypes.string,
  longDescription: PropTypes.string,
  breadCrumbs: PropTypes.shape({}),
  currentProduct: PropTypes.shape({}),
  productDetails: PropTypes.shape({}),
  currency: PropTypes.string,
  currencyAttributes: PropTypes.shape({}).isRequired,
  currentBundle: PropTypes.arrayOf(PropTypes.shape({})),
  handleAddToBag: PropTypes.func.isRequired,
  addToFavorites: PropTypes.func.isRequired,
  addToBagEcom: PropTypes.func.isRequired,
  currentState: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool,
  addToBagErrorId: PropTypes.string,
  addToBagError: PropTypes.string,
  isKeepAliveEnabled: PropTypes.bool.isRequired,
  AddToFavoriteErrorMsg: PropTypes.string,
  removeAddToFavoritesErrorMsg: PropTypes.func,
  topPromos: PropTypes.shape({}),
  isOnModelAbTestBundlePdp: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  isEnabledOutfitAddedCTA: PropTypes.bool,
  showAddedToBagCta: PropTypes.string,
  wishList: PropTypes.func.isRequired,
  onSetLastDeletedItemIdAction: PropTypes.func,
  isOutfitPage: PropTypes.bool,
  errorMessages: PropTypes.shape({}),
  isSyteEnabled: PropTypes.bool,
  trackAnalyticsClick: PropTypes.func,
  toastModalState: PropTypes.shape({
    duration: PropTypes.number,
    showToast: PropTypes.bool,
  }),
  showToastModalAction: PropTypes.func,
};

BundleProduct.defaultProps = {
  className: '',
  longDescription: '',
  shortDescription: '',
  itemPartNumber: '',
  breadCrumbs: [],
  productDetails: {},
  currentProduct: {},
  currentBundle: [{}, {}],
  currency: 'USD',
  isLoggedIn: false,
  addToBagErrorId: '',
  addToBagError: '',
  AddToFavoriteErrorMsg: '',
  removeAddToFavoritesErrorMsg: () => {},
  topPromos: null,
  isOnModelAbTestBundlePdp: false,
  isEnabledOutfitAddedCTA: false,
  showAddedToBagCta: '',
  onSetLastDeletedItemIdAction: () => {},
  isOutfitPage: false,
  errorMessages: {},
  isSyteEnabled: false,
  trackAnalyticsClick: () => {},
  toastModalState: {
    duration: 0,
    showToast: false,
  },
  showToastModalAction: () => {},
};

export default withStyles(BundleProduct, styles);
